import React, { useState, useEffect } from 'react';
import { serviceRequestStore } from '../store/data';
import { ChevronLeft, Phone, MapPin, Bike, ClipboardList } from 'lucide-react';
import logo from '../logo.png';
function StatusBadge({ status }) {
  const cfg = {
    pending: ['badge-yellow', 'Pending'],
    scheduled: ['badge-blue', 'Scheduled'],
    completed: ['badge-green', 'Completed'],
    cancelled: ['badge-gray', 'Cancelled'],
  };
  const [cls, label] = cfg[status] || ['badge-gray', status];
  return <span className={cls}>{label}</span>;
}

export default function TechnicianView({ onBack }) {
  const [requests, setRequests] = useState([]);
  const [filter, setFilter] = useState('active');

  useEffect(() => {
    serviceRequestStore.getAll().then(setRequests);
  }, []);

  const reload = () => serviceRequestStore.getAll().then(setRequests);

  const filtered = filter === 'active'
    ? requests.filter(r => r.status === 'pending' || r.status === 'scheduled')
    : filter === 'completed'
    ? requests.filter(r => r.status === 'completed')
    : requests;

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col max-w-md mx-auto">
      {/* Header */}
      <div className="px-5 pt-8 pb-5" style={{ background: 'linear-gradient(135deg, #081d31 0%, #1B4F72 100%)' }}>
        <div className="flex items-center justify-between mb-4">
          <button onClick={onBack} className="text-slate-400 hover:text-white flex items-center gap-1 text-sm">
            <ChevronLeft size={16} /> Exit
          </button>
          <div className="flex items-center gap-2">
            <img src={logo} alt="SevenStars" className="h-5 w-auto object-contain" style={{filter:'brightness(0) invert(1)'}} />
            <span className="text-white text-sm font-semibold">Tech View</span>
          </div>
        </div>
        <h1 className="text-white text-xl font-bold">Service Schedule</h1>
        <p className="text-slate-400 text-sm">SevenStars SmartCare · Romblon</p>
      </div>

      {/* Filter tabs */}
      <div className="px-4 pb-4 flex gap-2" style={{ backgroundColor: '#081d31' }}>
        {[['active', 'Active'], ['completed', 'Completed'], ['all', 'All']].map(([key, label]) => (
          <button key={key} onClick={() => setFilter(key)}
            className={`px-4 py-1.5 rounded-xl text-sm font-medium transition-all ${filter === key ? 'text-white' : 'bg-slate-700 text-slate-300 hover:bg-slate-600'}`}
            style={filter === key ? { backgroundColor: '#E87722' } : {}}>
            {label}
          </button>
        ))}
      </div>

      {/* Requests */}
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {filtered.length === 0 ? (
          <div className="card text-center py-10">
            <ClipboardList size={40} className="text-slate-300 mx-auto mb-3" />
            <p className="text-slate-500">No {filter === 'all' ? '' : filter} requests.</p>
          </div>
        ) : (
          filtered.sort((a, b) => a.preferredDate?.localeCompare(b.preferredDate || '') || 0).map(r => (
            <div key={r.id} className="card">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <div className="font-bold text-slate-800 text-lg">{r.name}</div>
                  <div className="flex items-center gap-1 text-slate-500 text-sm mt-0.5">
                    <MapPin size={13} /> {r.municipality}
                  </div>
                </div>
                <StatusBadge status={r.status} />
              </div>

              <div className="bg-slate-50 rounded-xl p-3 mb-3 space-y-1.5 text-sm">
                <div className="flex items-center gap-2">
                  <Bike size={14} className="text-brand-500 flex-shrink-0" />
                  <span className="font-medium text-slate-700">{r.model}</span>
                </div>
                <div className="text-slate-600">
                  <span className="font-medium text-accent-600">{r.issueCategory}:</span> {r.description}
                </div>
                {r.preferredDate && (
                  <div className="text-slate-500">📅 Visit Date: <span className="font-medium text-slate-700">{r.preferredDate}</span></div>
                )}
              </div>

              <div className="flex items-center justify-between">
                <a href={`tel:${r.contact}`}
                  className="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-all" style={{ backgroundColor: '#eef3f8', color: '#1B4F72' }}>
                  <Phone size={15} /> {r.contact}
                </a>
                <div className="flex gap-2">
                  {r.status !== 'completed' && (
                    <button onClick={() => { serviceRequestStore.updateStatus(r.id, 'completed').then(reload); }}
                      className="text-xs px-3 py-2 rounded-xl text-white font-medium transition-all" style={{ backgroundColor: '#1B4F72' }}>
                      Mark Done
                    </button>
                  )}
                  {r.status === 'pending' && (
                    <button onClick={() => { serviceRequestStore.updateStatus(r.id, 'scheduled').then(reload); }}
                      className="text-xs px-3 py-2 rounded-xl bg-blue-500 text-white font-medium hover:bg-blue-600 transition-all">
                      Schedule
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
